export default {
  checkUpdate: "检查更新",
  updateContent:
    "您的典枢当前版本不是最新版，点击“更新”同步至最新版本以获得更佳的用户体验！",
  update: "更新",
  cancel: "取消",
  updateComplete: "更新完成",
  updateCompleteContent:
    "您的典枢最新版本已更新完成，点击“安装”感受更佳的用户体验！",
  install: "安装",
};
